import {
  FETCH_OVERVIEW_DETAILS,
  FETCH_OVERVIEW_ERROR,
  FETCH_OVERVIEW_SUCCESS,
  SET_AREA_TYPE,
  FETCH_TOP_ASHA_TABLE_DETAILS,
  FETCH_TOP_ASHA_TABLE_DETAILS_SUCCESS,
  FETCH_TOP_ASHA_TABLE_DETAILS_FAILURE,
  FETCH_NOTIFICATION,
  FETCH_NOTIFICATION_FAILURE,
  FETCH_NOTIFICATION_SUCCESS,
  SET_DISTRICT_ID,
  FETCH_DISTRICT_ID,
  SET_TALUKA_ID,
  SET_PHC_ID,
  SEND_PHC_ID,
  SEND_TALUKA_ID,
  FETCH_ASHA_DEPLOYED_BY_REGION,
  FETCH_ASHA_DEPLOYED_BY_REGION_SUCCESS,
  FETCH_ASHA_DEPLOYED_BY_REGION_FAILURE,
  TOTAL_ASHA,
  TOTAL_ASHA_SUCCESS,
  TOTAL_ASHA_FAILURE,
} from "./DashboardActions";

const defaultState = {
  areaType: "",
  districtId: [],
  distId: [],
  talukaId: [],
  sendTaluka: [],
  sendPhc: [],
  phcId: [],
  overviewDetails: {},
  isLoading: false,
  totalAshaTableList: [],
  notificationList: {},
  AshaByRegion: [],
  error: [],
  totalAsha: [],
};

const DashboardReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_AREA_TYPE:
      return { ...state, areaType: action.payload };
    case SEND_PHC_ID:
      return { ...state, sendPhc: action.payload };
    case SEND_TALUKA_ID:
      return { ...state, sendTaluka: action.payload };
    case FETCH_DISTRICT_ID:
      return { ...state, distId: action.payload };
    case SET_PHC_ID:
      return { ...state, phcId: action.payload };
    case SET_DISTRICT_ID:
      return { ...state, districtId: action.payload };
    case SET_TALUKA_ID:
      return { ...state, talukaId: action.payload };
    case FETCH_OVERVIEW_DETAILS:
      return { ...state, isLoading: true };
    case FETCH_OVERVIEW_SUCCESS:
      return { ...state, isLoading: false };
    case FETCH_OVERVIEW_ERROR:
      return { ...state, isLoading: false };
    case FETCH_TOP_ASHA_TABLE_DETAILS:
      return { ...state };
    case FETCH_TOP_ASHA_TABLE_DETAILS_FAILURE:
      return { ...state, error: action.payload };
    case FETCH_TOP_ASHA_TABLE_DETAILS_SUCCESS:
      return { ...state, totalAshaTableList: action.payload };
    case FETCH_NOTIFICATION:
      return { ...state, isLoading: true };
    case FETCH_NOTIFICATION_SUCCESS:
      return { ...state, isLoading: false, notificationList: action.payload };
    case FETCH_NOTIFICATION_FAILURE:
      return { ...state, isLoading: false };
    case FETCH_ASHA_DEPLOYED_BY_REGION:
      return { ...state };
    case FETCH_ASHA_DEPLOYED_BY_REGION_SUCCESS:
      return { ...state, isLoading: false, AshaByRegion: action.payload };
    case FETCH_ASHA_DEPLOYED_BY_REGION_FAILURE:
      return { ...state, isLoading: false };
    case TOTAL_ASHA:
      return { ...state,isLoading:true, paginationData: {}, };
    case TOTAL_ASHA_SUCCESS:
      return { ...state, isLoading: false, totalAsha: action.payload, paginationData: action.paginationData };
    case TOTAL_ASHA_FAILURE:
      return { ...state, isLoading: false, paginationData: {} };
    default:
      return state;
  }
};
export default DashboardReducer;
